<template>
    <ion-header
        style="
            -webkit-box-shadow: none;
            box-shadow: none;
            border-bottom: var(--ion-color-medium-tint);
            border-bottom-style: solid;
            border-bottom-width: 1px;
        "
    >
        <ion-toolbar mode="md">
            <ion-title style="font-family: 'San Francisco', sans-serif; font-weight: 700; text-align: center"
                >Widget Settings</ion-title
            >
        </ion-toolbar>
    </ion-header>
    <ion-content class="ion-no-padding" style="--background: white">
        <ion-list lines="none">
            <ion-item>
                <ion-toggle v-model="inquiriesWidgetValue">Inquiries Widget</ion-toggle>
            </ion-item>
            <ion-item>
                <ion-toggle v-model="pendingWidgetValue">Pending Widget</ion-toggle>
            </ion-item>
            <ion-item>
                <ion-toggle v-model="arrivalsWidgetValue">Arrivals Widget</ion-toggle>
            </ion-item>
            <ion-item>
                <ion-toggle v-model="departuresWidgetValue">Departures Widget</ion-toggle>
            </ion-item>
            <ion-item>
                <ion-toggle v-model="occupancyWidgetValue">Occupancy Widget</ion-toggle>
            </ion-item>
        </ion-list>

        <div style="padding-top: 110px"></div>

        <ion-grid mode="ios" class="ldx-bottom-fixed">
            <ion-row>
                <ion-col>
                    <ion-button
                        style="
                            width: -webkit-fill-available;
                            border-radius: 10px;
                            --border-width: 2px;
                            --border-style: solid;
                            --border-color: var(--ion-color-primary);
                        "
                        color="primary"
                        @click="cancel"
                        >Close</ion-button
                    >
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-content>
</template>

<script lang="ts">
    import { useStore } from '@/store/store';
    import { modalController } from '@ionic/vue';
    import { defineComponent, ref, onMounted, watch } from 'vue';
    import { checkmarkCircleOutline, person, mail } from 'ionicons/icons';

    export default defineComponent({
        components: {},
        setup() {
            const store = useStore();

            const cancel = () => {
                return modalController.dismiss(null, 'cancel');
            };

            onMounted(() => {
                //
            });

            const inquiriesWidgetValue = ref(store.showInquiriesWidget);

            watch(
                () => inquiriesWidgetValue.value,
                (value) => {
                    store.changeShowInquiriesWidget(value);
                }
            );

            watch(
                () => store.showInquiriesWidget,
                (value) => {
                    inquiriesWidgetValue.value = value;
                }
            );

            const pendingWidgetValue = ref(store.showPendingWidget);

            watch(
                () => pendingWidgetValue.value,
                (value) => {
                    store.changeShowPendingWidget(value);
                }
            );

            watch(
                () => store.showPendingWidget,
                (value) => {
                    pendingWidgetValue.value = value;
                }
            );

            const arrivalsWidgetValue = ref(store.showArrivalsWidget);

            watch(
                () => arrivalsWidgetValue.value,
                (value) => {
                    store.changeShowArrivalsWidget(value);
                }
            );

            watch(
                () => store.showArrivalsWidget,
                (value) => {
                    arrivalsWidgetValue.value = value;
                }
            );

            const departuresWidgetValue = ref(store.showDeparturesWidget);

            watch(
                () => departuresWidgetValue.value,
                (value) => {
                    store.changeShowDeparturesWidget(value);
                }
            );

            watch(
                () => store.showDeparturesWidget,
                (value) => {
                    departuresWidgetValue.value = value;
                }
            );

            const occupancyWidgetValue = ref(store.showOccupancyWidget);

            watch(
                () => occupancyWidgetValue.value,
                (value) => {
                    store.changeShowOccupancyWidget(value);
                }
            );

            watch(
                () => store.showOccupancyWidget,
                (value) => {
                    occupancyWidgetValue.value = value;
                }
            );

            return {
                cancel,
                inquiriesWidgetValue,
                pendingWidgetValue,
                arrivalsWidgetValue,
                departuresWidgetValue,
                occupancyWidgetValue,
            };
        },
    });
</script>

<style scoped>
    ion-button {
        --background: var(--ion-color-primary);
        --border-radius: 10px;
        --background-activated: var(--ion-color-primary-tint);
    }

    ion-item {
        --background: transparent;
        padding: 0px !important;
        margin: 0px;
    }

    ion-list {
        --background: transparent;
        padding: 0px !important;
        margin: 5px;
    }
</style>
